/* GE design elevation — scroll reveal + editorial image load-in.
 *
 * Contract:
 * - Default-visible: this file only ever ADDS the revealed state on top of
 *   fully rendered content. The hidden state comes from <html class="ge-motion">,
 *   which theme.liquid sets inline, pre-paint, only when JS runs and
 *   prefers-reduced-motion is not requested. No class => nothing hidden.
 * - One-shot: every observed element is unobserved the moment it reveals.
 * - transform + opacity only; durations/easing come from --ge-* tokens.
 * - The buying path (PLP grids, PDP, cart) carries no .ge-reveal hooks.
 */

(function () {
  // Signal to theme.liquid's inline safety-net timeout that the reveal layer
  // is alive; if this script never runs, the timeout disarms .ge-motion so
  // .ge-reveal content can never stay permanently hidden.
  window.geRevealReady = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REVEAL_SELECTOR = '.ge-reveal';
  var REVEALED_CLASS = 'ge-reveal--in';

  function revealNow(element) {
    element.classList.add(REVEALED_CLASS);
  }

  function initReveals(rootEl) {
    var elements = Array.prototype.slice.call((rootEl || document).querySelectorAll(REVEAL_SELECTOR));
    if (elements.length === 0) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      elements.forEach(revealNow);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          // rAF so one hidden frame paints first — the entrance transition
          // then reliably plays even for elements already in view at load.
          requestAnimationFrame(function () {
            revealNow(entry.target);
          });
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  /* Editorial image load-in: fade + settle when the pixels actually arrive.
     Scoped to marketing imagery only — never product cards, never the LCP
     hero image (it has fetchpriority=high and must not opacity-animate). */
  var IMAGE_SELECTOR = '.image-with-text__media img, .ge-brand-statement__media img';

  function initImageLoadIn(rootEl) {
    if (REDUCED) return;
    var images = Array.prototype.slice.call((rootEl || document).querySelectorAll(IMAGE_SELECTOR));
    images.forEach(function (img) {
      // Already resolved before this deferred script ran — loaded OR errored
      // (complete + naturalWidth 0). Either way, leave it plain: never hide an
      // image (or its alt-text fallback) whose load/error event already fired.
      if (img.complete) return;
      img.classList.add('ge-image-load');
      var done = function () {
        requestAnimationFrame(function () {
          img.classList.add('ge-image-load--in');
        });
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true }); // never leave a broken image hidden
    });
  }

  function init(rootEl) {
    initReveals(rootEl);
    initImageLoadIn(rootEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: sections re-render via AJAX — re-arm inside the new node.
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
